import { produce } from 'immer'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { InstallationRepository } from '@context/Installations/domain/InstallationRepository'
import { ApiInstallationRepository } from '@context/Installations/infrastructure/ApiInstallationRepository'

const repository = ApiInstallationRepository()

export type InstallationStore = {
  repository: InstallationRepository
  isEditInstallation: boolean
  installationSettingsTab: number
  setInstallationSettingsTab: (tab: number) => void
}

export type FilterSearch = {
  name: Nullable<string>
}

export type Installations = InstallationStore &
  FilterSearch & {
    setFilterName: (name: Nullable<string>) => void
    toggleIsEditInstallation: () => void
  }

const initialInstallationsState: InstallationStore & FilterSearch = {
  repository: repository,
  isEditInstallation: false,
  name: null,
  installationSettingsTab: 0,
  setInstallationSettingsTab: () => {},
}

export const installationStore = create<Installations>()(
  devtools(
    (set) => ({
      ...initialInstallationsState,
      setFilterName: (name) =>
        set(
          produce((draft: Installations) => {
            draft.name = name
          }),
          false,
          'setFilterName',
        ),
      setInstallationSettingsTab: (tab: number) =>
        set({ installationSettingsTab: tab }, false, 'setInstallationSettingsTab'),
      toggleIsEditInstallation: () =>
        set(
          produce((draft: Installations) => {
            draft.isEditInstallation = !draft.isEditInstallation
          }),
          false,
          'toggleIsEditInstallation',
        ),
    }),

    { name: 'Installation' },
  ),
)
